import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import { useStyles } from './ActionBar.styles';
export default function ActionBar(props) {
    const classes = useStyles();
    const { navigateForward, navigateBack, customText, customIcon, disabled, stickyInMobile, isSubmit } = props;
    return (React.createElement(Box, { component: "div", sx: [classes.root, stickyInMobile && classes.stickyInMobile] },
        navigateBack && (React.createElement(Button, { variant: "outlined", onClick: navigateBack, sx: classes.goBackLink, size: "large" }, customIcon ? customIcon : React.createElement(ArrowBackIcon, null))),
        navigateForward && (React.createElement(Button, { variant: "contained", onClick: navigateForward, disabled: disabled, size: "large", color: "primary", sx: classes.forward, type: isSubmit ? 'submit' : undefined }, customText ? customText : 'Fortsätt'))));
}
